import ProductsCell from './ProductsCell';

export default ProductsCell;
